import { coreUIAvailableThemes } from '@scality/core-ui/dist/style/theme';

export const theme = {
  ...coreUIAvailableThemes['G-Dark'],
  chatCardGray: '#323244',
  chatCardBlue: '#233b71',
};
